import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import { styled as styling } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Color from "../../../assets/colors";

// Dialog Container
export const CurrentSalaryDialogStyled = styling(Dialog)(({ theme }) => ({
  "&&": {
    ".MuiDialog-container .MuiPaper-root": {
      borderRadius: "24px",
      padding: 0,
      display: "flex",
      flexDirection: "column",
      maxWidth: "670px",
      height: "700px",
      width: "100%",
      boxSizing: "border-box",
    },
    "& .MuiBackdrop-root": {
      backdropFilter: "blur(16px)",
      backgroundColor: "#7a7a7a66",
    },
    ".MuiDialog-paper": {
      border: "2px solid black",
    },
    ".center": {
      display: "flex",
      justifyContent: "center",
    },
  },

    [theme.breakpoints.down("md")]: {
    "&&": {
      ".MuiDialog-container .MuiPaper-root": {
        // maxWidth: "670px",
        // height: "700px",
        maxWidth: "calc(100% - 32px)",
        height: "auto",
        width: "100%",
      },
    },
  },

  [theme.breakpoints.down("sm")]: {
    "&&": {
      ".MuiDialog-container .MuiPaper-root": {
          // maxWidth: "calc(100% - 32px)",
          // height: "525px",
          width: "335px",
      },
    },
},
}));

// Dialog Title
export const DialogTitleContainer = styling(Box)(({ theme }) => ({
  borderBottom: `1px solid ${Color.secondaryGrey}`,
  height: "64px",
  padding: "24px 24px 16px",
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  [theme.breakpoints.down("md")]: {
    height: "auto",
      padding: "24px 24px 16px",
  },

  [theme.breakpoints.down("sm")]: {
    height: "auto",
    padding: "24px 18px 16px",
  }
}));

export const DialogTitleStyled = styling(DialogTitle)(({ theme }) => ({
  padding: 0,
  flexGrow: 1,
  textAlign: 'left',

  "& .MuiTypography-root": {
    fontFamily: "Inter",
    fontWeight: "bold",
    color: "black",
    fontSize: "20px",
  },

  [theme.breakpoints.down("sm")]: {
    "& .MuiTypography-root": {
      fontSize: "16px",
    },
  },
}));

// Dialog Content
export const DialogContentStyledWrapper = styling(DialogContent)(({theme}) => ({
  textAlign: "left",
  padding: "16px 16px 24px",
  height: "636px",
  boxSizing: "border-box",
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  [theme.breakpoints.down("md")]: {
    padding: "16px 24px 24px",
    height: "auto",

  },
  [theme.breakpoints.down("sm")]: {
    padding: "8px 16px 16px",
    width: "100%",
  }
}));

// Image
export const CurrentSalaryImg = styling("img")(({ theme }) => ({
  width: '400px',
  height: '225px',
  objectFit: 'cover',
  border: '1px solid #E0E0E0',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
  margin: '0px auto 16px',

  [theme.breakpoints.down("md")]: {
    margin: '0px auto 16px',
  },

  [theme.breakpoints.down("sm")]: {
    width: '120px',
    height: '120px',
    margin: '0px auto 8px',
  }
}));

export const InfoSectionWrapper = styling(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 8,
  
  "& .MuiTypography-root": {
    fontWeight: "bold",
    color: "black",
  },

});

// Text
export const CurrentSalarySubTitle = styling(Typography)(({theme}) => ({
  fontSize: "20px",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  lineHeight: "24px",

  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
  },
}));

export const InfoText = styling(Typography)(({ theme }) => ({
  marginBottom: 16,
  color: theme.palette.text.secondary,
  fontSize: "16px",
  textAlign: 'left',
  maxWidth: "600px",
  width: '100%',
  lineHeight: "20px",

  "&:last-of-type": {
    marginBottom: 24,
  },

  "& .MuiLink-root": {
    fontWeight: "bold",
    color: "black",
    textDecoration: "none",

    "&:hover": {
      textDecoration: "underline",
    },
  },

  [theme.breakpoints.down("sm")]: {
    marginBottom: "8px",
    fontSize: "12px",
    textAlign: "center",
    maxWidth: "296px",

    "&:last-of-type": {
        marginBottom: 16,
    },
  },
}));

// Gross Salary Container
export const GrossSalaryWrapper = styling(Box)(({theme}) => ({
  backgroundColor: '#F5F5F5',
  borderRadius: '10px',
  padding: "12px",
  textAlign: 'left',
  width: '622px',
  height: "167px",
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  [theme.breakpoints.down("sm")]: {
    padding: "12px",
    width: '295px',
    height: "125px",
  }
}));

export const GrossSalaryLabel = styling(Typography)(({theme}) => ({
  color: "rgba(0, 0, 0, 0.60)",
  fontSize: "16px",
  fontFamily: "Inter",
  letterSpacing: "0.15px",
  marginBottom: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    marginBottom: "8px",
  }
}));

export const SalaryInputDisplayRow = styling(Box)(({theme}) => ({
  display: "flex",
justifyContent: 'center',
  alignItems: "center",
  gap: "8px",

  [theme.breakpoints.down("sm")]: {
    gap: "8px",
  },
}));

export const StyledAdornmentLabel = styling("span")(({theme}) => ({
  backgroundColor: "#EFEFEF",
  borderRadius: "4px",
  padding: "0 4px",
  display: "flex",
  justifyContent: 'center',
  alignItems: "center",
  backgroundColor: "#EFEFEF",
  color: "rgba(0, 0, 0, 0.38)",
  fontSize: "14px",
  lineHeight: "1.5",
  width: "auto",
  marginLeft: "115px",
  display: "inline-block",

  [theme.breakpoints.down("sm")]: {
    marginLeft: "55px",
    fontSize: "12px",
  }
}));

export const RmText = styling(Typography)(({theme}) => ({
  color: "rgba(0, 0, 0, 0.60)",
  fontSize: "16px",
  fontWeight: "bold",

  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  }
}));

export const SalaryInputField = styling(TextField)(({theme}) => ({
  flexGrow: 0,
  width: 'auto',

  "& .MuiInputBase-root": {
    backgroundColor: 'transparent',
    border: 'none',
    height: 'auto',
    padding: 0,
  },

  "& .MuiInputBase-input": {
    textAlign: "left",
    fontWeight: "bold",
    color: "rgba(0, 0, 0, 0.60)",
    padding: 0,
    fontSize: "16px",
  },

  "& .MuiOutlinedInput-notchedOutline": { border: 'none' },
  "& .MuiInput-underline:before": { borderBottom: 'none !important' },
  "& .MuiInput-underline:after": { borderBottom: 'none !important' },
  "& .MuiInputBase-input::placeholder": {
    color: "rgba(0, 0, 0, 0.60)",
    opacity: 1,
    fontWeight: 'bold',
  },

  [theme.breakpoints.down("sm")]: {
  "& .MuiInputBase-root": {
    backgroundColor: 'transparent',
    border: 'none',
    height: 'auto',
    padding: 0,
  },

  "& .MuiInputBase-input": {
    textAlign: "left",
    fontWeight: "bold",
    color: "rgba(0, 0, 0, 0.60)",
    fontSize: "14px",
  },
  }
}));


// Button
export const CloseButtonWrapper = styling(Box)(({theme}) => ({
  position: "absolute",
  top: 16,
  right: 16,
  cursor: "pointer",

  "& .MuiIconButton-root": {
    color: "#000",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },

  [theme.breakpoints.down("sm")]: {
    top: 16,
    right: 4,
  }
}));

export const ButtonsWrapper = styling(Box)(({theme}) => ({
  display: "flex",
  justifyContent: "center",
  gap: '16px',
  marginTop: "10px",
  marginBottom: 0,

  [theme.breakpoints.down("sm")]: {
    marginTop: "8px",
    gap: "10px",
  }
}));

export const MaybeLaterButton = styling(Button)(({ theme }) => ({
  height: "42px",
  width: "162px",
  borderRadius: 100,
  color: "rgba(0, 0, 0, 0.87)",
  border: "1px solid #222",
  backgroundColor: "white",
  fontSize: "16px",
  fontWeight: 700,
  textTransform: "none",

  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    height: "30px",
    width: "auto",
    padding: "0 32px",
  }
}));

export const AddNowButton = styling(Button)(({ theme }) => ({
  height: "42px",
  width: "162px",
  borderRadius: 100,
  backgroundColor: "#353535",
  color: "white",
  fontSize: "16px",
  fontWeight: 700,
  textTransform: "none",

  "&.Mui-disabled": {
    background: "rgba(0, 0, 0, 0.38)",
    color: Color.white,
  },

  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    height: "30px",
    width: "auto",
    padding: "0px 32px",
  }
}));

export const DoNotShowAgainStyled = styling(Typography)(({ theme }) => ({
  color: "rgba(0, 0, 0, 0.87)",
  textDecoration: "underline",
  marginTop: 16,
  cursor: "pointer",
  fontSize: "16px",
  fontFamily: "inter",
  fontWeight: 500,
  letterSpacing: "0.074px",
  display: 'block',

  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    marginTop: 10,
  }
}));

// Divider
export const DividerStyled = styling(Divider)(({theme}) => ({
  width: "580px",
  height: "0.8px",
  color: "rgba(0, 0, 0, 0.60)",
  marginBottom: "16px",

  [theme.breakpoints.down("sm")]: {
    marginBottom: "8px",
    width: "265px",
  }
}));